import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Badge, Box, Button, Drawer, IconButton, Tooltip, Typography, TextField, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { UploadEvidence } from "../../../../../../../../components/uploadEvidence";
import { Evidence, EvidenceTypeData, EVIDENCE_TYPES } from "./types";
import { reportFolioServices } from "../../../../../../../../utils/constants/callService";
import { useGetData } from "../../hooks/useGetData";
import { ConfirmModal } from "../historial/Components";
import { SnackSimple } from "../../../../../../../../components";
import { Types } from "../../../../../../../../utils/enums/types";
import { VIEW_TYPES } from './../../types/ViewTypes';

export const SendSolutionOrQuotation = ({ onAttend }) => {
    const styles = useStyles();
    const { t } = useTranslation();
    const { id } = useParams();
    const { data, getHistorial } = useGetData({ id });
    useEffect(() => {
        getHistorial();
    }, []);
    const { historial, left } = data;
    const [alertModals, setAlertModals] = useState(false);
    const [messageAlertModals, setMessageAlertModals] = useState("");
    const [openUploadEvidence, setOpenUploadEvidence] = useState(false);
    const [evidencesRequiredAreLoad, setEvidencesRequiredAreLoad] = useState({});
    const [commentUpload, setCommentUpload] = useState("");
    const [isLoading, setIsLoading] = useState(true); // Indicador de carga
    const [evidencesDrawer, setEvidencesDrawer] = useState({
        open: false,
        type: {
            equivalence: [],
            accept: "",
        },
        value: {},
    });
    const [modalOpen, setModalOpen] = useState(false);
    let idQuote: number;
    if (historial) {
        idQuote = historial.items[0].idQuote;
    }
    const isSolution = historial?.items[0].type === "SOLUTION";
    const countFolio = left?.folio
    const idFolio = left?.id

    useEffect(() => {
        const evidenceConfig: any = {};
        Object.values(EVIDENCE_TYPES).forEach((type) => {
            evidenceConfig[type.id] = {
                expanded: false,
                seeFiles: true,
                required: false,
                customeTitle: type.description,
                maxCount:
                    type.key === "camera" || type.key === "image" || type.key === "video" || type.key === "video_gallery"
                        ? 10
                        : 1,
                minAmount: 0,
                size:
                    type.key === "comment" || type.key === "comment_approve"
                        ? 255
                        : type.key === "video" || type.key === "image" || type.key === "video_gallery"
                            ? 10
                            : 1,
                value: {},
                accept:
                    type.types?.map((t) => `.${t}`).join(",") ||
                    (type.key === "image" || type.key === "camera" ? "image/*" : ""),
            };
        });

        setEvidencesDrawer((prev) => ({
            ...prev,
            value: evidenceConfig,
            open: prev.open,
        }));

        setTimeout(() => setIsLoading(false), 1000);
    }, []);

    const handleOpenUpload = () => {
        setOpenUploadEvidence(true);
        setEvidencesDrawer((prev) => ({
            ...prev,
            open: true,
        }));
    };

    const handleCloseUpload = () => {
        setOpenUploadEvidence(false);
        setEvidencesDrawer((prev) => ({
            ...prev,
            open: false,
        }));
    };

    const handleSentData = async () => {
        const evidences: Evidence[] = [];
        if (evidencesDrawer.value) {
            Object.entries(evidencesDrawer.value).forEach(([typeId, typeData]) => {
                const typeDataTyped = typeData as EvidenceTypeData;
                if (typeDataTyped.value) {
                    Object.values(typeDataTyped.value).forEach((file) => {
                        evidences.push({
                            evidenceTypeId: parseInt(typeId, 10),
                            originalname: file.name,
                            url: file.url,
                        });
                    });
                }
            });
        }

        let response;
        if (isSolution) {
            response = await reportFolioServices.sendSolution(
                {
                    evidences,
                    description: commentUpload,
                },
                idFolio ?? 0
            );
        } else {
            response = await reportFolioServices.sendQuote(
                {
                    evidences,
                    commentUpload,
                },
                idQuote
            );
        }

        if (response.code === "00" || response.id) {
            setMessageAlertModals(
                isSolution
                    ? t("reportFolio.detail.general.confirmSolutionTitleSuccess")
                    : t("reportFolio.detail.general.confirmQuotationTitleSucces")
            );
            setAlertModals(true);
            setModalOpen(false);
            onAttend(VIEW_TYPES.TAB_SWITCHER);
        } else {
            setMessageAlertModals(
                isSolution
                    ? t("reportFolio.detail.general.confirmSolutionTitleError")
                    : t("reportFolio.detail.general.confirmQuotationTitleError")
            );
            setAlertModals(true);
            setModalOpen(false);
        }
    };

    const handleCloseAlertsModal = () => {
        setAlertModals(false);
    };

    if (isLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Box sx={styles.container}>
                <Box sx={styles.centerContainer}>
                    <Typography fontWeight="bold">
                        {isSolution ? t("reportFolio.detail.general.sendSolutionTitle") : t("reportFolio.detail.general.sendQuotationTitle")}
                    </Typography>

                    <Typography>
                        {isSolution ? t("reportFolio.detail.general.sendSolutionDescription") : t("reportFolio.detail.general.sendQuotationDescription")}
                    </Typography>

                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        value={commentUpload}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 255) {
                                setCommentUpload(value);
                            }
                        }}
                        label={t("general.comment")}
                        margin="normal"
                        error={commentUpload.length > 255}
                        inputProps={{ maxLength: 255 }}
                    />

                </Box>
            </Box>

            <Box sx={styles.buttonsContainer}>
                <Button onClick={onAttend}>{t("general.cancel")}</Button>

                <Box sx={styles.lastButtons}>
                    <Badge
                        sx={styles.badge}
                        badgeContent={
                            evidencesDrawer.value
                                ? Object.values(evidencesDrawer.value).reduce((count, type) => {
                                    const typeValue = (type as { value?: Record<string, unknown> })?.value || {};
                                    return count + Object.keys(typeValue).length;
                                }, 0)
                                : 0
                        }
                    >
                        <Tooltip title={t("ToolTips.seeEvidences")}>
                            <IconButton onClick={handleOpenUpload} sx={styles.clip}>
                                {icons("clip")}
                            </IconButton>
                        </Tooltip>
                    </Badge>
                    <Button
                        variant="contained"
                        onClick={() => setModalOpen(true)}
                        disabled={!commentUpload.trim() || commentUpload.length > 255}
                    >
                        {isSolution ? t("reportFolio.detail.general.sendSolutionTitle") : t("reportFolio.detail.general.sendQuotationTitle")}
                    </Button>
                </Box>
            </Box>

            <Drawer
                anchor="right"
                open={evidencesDrawer.open}
                onClose={handleCloseUpload}
                PaperProps={{
                    sx: {
                        width: "30%",
                    },
                }}
            >
                <Box p={2} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    <Typography variant="h6" gutterBottom>
                        {t("reportFolio.detail.general.evidencesDetail")}
                    </Typography>

                    {openUploadEvidence && (
                        <UploadEvidence
                            uploadName={`folios/${countFolio}/quote`}
                            evidencesDrawer={evidencesDrawer}
                            evidencesRequiredAreLoad={evidencesRequiredAreLoad}
                            showRequireds={false}
                            setEvidencesDrawer={setEvidencesDrawer}
                            setEvidencesRequiredAreLoad={setEvidencesRequiredAreLoad}
                            close={handleCloseUpload}
                        />
                    )}
                </Box>
            </Drawer>

            <ConfirmModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={handleSentData}
                title={isSolution ? t("reportFolio.detail.general.sendSolutionTitle") : t("reportFolio.detail.general.sendQuotationTitle")}
                description={isSolution ? t("reportFolio.detail.general.confirmSolutionEvidences") : t("reportFolio.detail.general.confirmQuotationEvidences")}
            />
            <SnackSimple
                open={alertModals}
                close={handleCloseAlertsModal}
                message={messageAlertModals}
                type={Types.SUCCESS}
            />
        </Box>
    );
};